import React from 'react';
import {Link} from 'react-router-dom';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import Yup from '../../../yup';
import messages from '../../../../res/translations/messages';
import Error from '../../Error';

const SurveyWaveFormSchema = Yup.object().shape({
    name: Yup.string().required(),
    startDate: Yup.string(),
    endDate: Yup.string(),
});

const WaveForm = ({submitting, surveyId, onSubmit, ...rest}) => {
    const handleSubmit = React.useCallback((values) => {
        const {startDate, endDate, ...rest} = values;
        const data = {...rest};
        if (startDate) {
            data.startDate = moment(startDate, 'YYYY-MM-DD').toISOString();
        }
        if (endDate) {
            data.endDate = moment(endDate, 'YYYY-MM-DD').toISOString();
        }
        onSubmit(data);
    }, [onSubmit]);

    return (
        <Formik validationSchema={SurveyWaveFormSchema} onSubmit={handleSubmit} {...rest}>
            <Form>
                <div className="form-group">
                    <label className="col-form-label" htmlFor="waveform_name"><FormattedMessage {...messages.waves.form.name} /></label>
                    <Field name="name" type="text" className="form-control" id="waveform_name" />
                    <ErrorMessage name="name">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
                <div className="row">
                    <div className="col form-group">
                        <label className="col-form-label" htmlFor="waveform_startDate"><FormattedMessage {...messages.waves.form.startDate} /></label>
                        <Field name="startDate" type="date" className="form-control" id="waveform_startDate" pattern="\d{4}-\d{2}-\d{2}"
                            placeholder="aaaa-mm-gg" />
                        <ErrorMessage name="startDate">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </div>
                    <div className="col form-group">
                        <label className="col-form-label" htmlFor="waveform_endDate"><FormattedMessage {...messages.waves.form.endDate} /></label>
                        <Field name="endDate" type="date" className="form-control" id="waveform_endDate" pattern="\d{4}-\d{2}-\d{2}"
                            placeholder="aaaa-mm-gg" />
                        <ErrorMessage name="endDate">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </div>
                </div>
                <div className="text-right">
                    <Link type="button" className="btn btn-outline-secondary mr-3" to={`/surveys/${surveyId}/trackers`}>
                        <FormattedMessage {...messages.waves.button.cancel} />
                    </Link>
                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                        <FormattedMessage {...messages.waves.button.save} />
                    </button>
                </div>
            </Form>
        </Formik>
    );
};

export default WaveForm;
